<template>
	<div>
		<v-form ref="tc_form">
			<v-text-field
				:class="dense ? 'grv-input-dense' : 'grv-input'"
				class="d-inline-flex"
				v-model="tc"
				style="width: 160px"
				:name="param.name"
				:rules="rules"
				@update:error="errored = $event"
				:mask="is_drop_frame ? '##:##:##;##' : '##:##:##:##'"
				@change="emitValue()"
				:readonly="readonly">
				<template v-slot:label>
					<Label :param="param"></Label>
				</template>
				<template v-slot:append>
					<v-btn
						flat icon
						:disabled="tc === tc_default && fps === fps_default"
						class="d-inline-flex ma-0"
						@click="raz()">
						<v-icon>close</v-icon>
					</v-btn>
				</template>
			</v-text-field>

			<v-autocomplete
				:class="dense ? 'grv-input-dense' : 'grv-input'"
				class="d-inline-flex"
				v-model="fps"
				style="width: 170px"
				@change="emitValue()"
				:items="fps_enum"
				:rules="rules"
				:menu-props="{contentClass: 'grv-menu'}"
				prefix="@"
				:readonly="readonly">
			</v-autocomplete>

			<span class="d-inline-flex">{{ value }}</span>
		</v-form>

		<Hint :param="param" :errored="errored"></Hint>
	</div>
</template>

<script>
import Label from '@/components/fields/label.vue'
import Hint from '@/components/fields/hint.vue'
import TimeCode from 'smpte-timecode'
export default {
	props: [
		'param',
		'value',
		'readonly',
		'dense'
	],
	components: {
		Label,
		Hint
	},
	data () {
		return {
			rules: [],
			errored: false,
			tc: '',
			tc_default: '00000000',
			fps: '25',
			fps_default: '25',
			fps_enum: [
				'23.98',
				'24',
				'25',
				'29.97 NDF',
				'29.97 DF',
				'30'
			]
		}
	},
	computed: {
		is_drop_frame () {
			return this.fps === '29.97 DF'
		}
	},
	watch: {
		value (val) {
			this.setTimecode(val)
		}
	},
	methods: {
		fillTimecode () {
			let filled = ''
			for (let i = 0; i < this.tc.length; i++) {
				if (i === 2) filled += ':'
				if (i === 4) filled += ':'
				if (i === 6) this.is_drop_frame ? filled += ';' : filled += ':'
				filled += this.tc[i]
			}
			if (filled.length !== 11) {
				for (let i = filled.length; i < 11; i++) {
					if (i === 2) {
						filled += ':'
					} else if (i === 5) {
						filled += ':'
					} else if (i === 8) {
						this.is_drop_frame ? filled += ';' : filled += ':'
					} else {
						filled += '0'
					}
				}
			}
			return filled
		},
		raz () {
			this.fps = this.fps_default
			this.tc = this.tc_default
			this.emitValue()
		},
		emitValue () {
			this.$refs.tc_form.validate()
			let value = ''
			value += this.fillTimecode()
			if (this.fps) {
				let fps = this.fps.replace(/ DF| NDF/g, '')
				value += `@${fps}`
			}
			this.$emit('update:value', value)
		},
		setTimecode (val) {
			this.tc = val.split('@')[0].replace(/:/g, '')
			let fps = val.split('@')[1] || '25'
			if (fps === '29.97') {
				if (val.indexOf(';') === 8) {
					this.fps = '29.97 DF'
				} else {
					this.fps = '29.97 NDF'
				}
			} else {
				// TODO: Non handled fps
				this.fps = fps
			}
		},
		requiredCheck (value) {
			if (value === '') return 'Requis'
			if (value === null) return 'Requis'
			if (value === undefined) return 'Requis'
			return true
		},
		timecodeCheck () {
			try {
				let duration = this.fillTimecode()
				let fps = this.fps
				if (!fps) fps = '25'
				fps = fps.replace(/ DF| NDF/g, '')
				fps = parseFloat(fps)
				if (fps === 23.98) fps = 23.976
				let dropFrame = this.is_drop_frame
				TimeCode(duration, fps, dropFrame)
				return true
			} catch (e) {
				console.log('timecodeCheck', e)
				return 'Timecode invalide'
			}
		}
	},
	mounted () {
		// TODO: set tc_default and fps_default based on param default value
		if (!this.param) return
		this.setTimecode(this.value)
		if (this.param.required || this.param.required === undefined) {
			this.rules.push(this.requiredCheck)
		}
		this.rules.push(this.timecodeCheck)
	}
}
</script>

<style lang="stylus" scoped>
.grv-input
.grv-input-dense
	>>>.v-select__slot
		.v-text-field__prefix
			color: var(--v-background-lighten4)
</style>



// WEBPACK FOOTER //
// src/components/fields/timecode.vue